import { useProperty, useTranslation } from '@eti/providers';
import { breakpoints, Button, Stack } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import DirectFlightCheckBoxNew from './DirectFlightCheckBoxNew';
import ZeroWidthSpace from './ZeroWidthSpace';

const buttonWrapperStyles = (isMultiStop?: boolean, isStopoverEnabled?: boolean) => css`
  place-content: space-between;

  @media (min-width: ${breakpoints._768}) {
    flex-direction: ${isStopoverEnabled ? 'column' : 'column-reverse'};
    margin-inline-start: ${!isMultiStop ? '24px' : '0'};
  }
`;

const buttonStyles = css`
  height: 48px;
  width: 100%;

  @media ${mediaQueries.large.up} {
    min-width: 180px;
  }
`;

type SubmitButtonNewProps = {
  isDatePassengerFieldsOpen?: boolean;
  isMultiStop?: boolean;
  isStopoverEnabled?: boolean;
};

const SubmitButtonNew = ({
  isDatePassengerFieldsOpen,
  isMultiStop,
  isStopoverEnabled,
}: SubmitButtonNewProps) => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const showDirectFlight =
    !p('SearchForm.ShowExtendedForm.Enabled') &&
    !isMultiStop &&
    isDatePassengerFieldsOpen &&
    !p('Searchform.Stopover.Enabled');

  return (
    <Stack
      className={buttonWrapperStyles(isMultiStop, isStopoverEnabled)}
      spacing={{ [breakpoints._0]: 0, [breakpoints._768]: 24 }}
    >
      {showDirectFlight && (
        <Stack spacing={4}>
          <ZeroWidthSpace />
          <DirectFlightCheckBoxNew />
        </Stack>
      )}
      <Stack spacing={4}>
        <ZeroWidthSpace />
        <Button
          className={buttonStyles}
          data-testid="searchForm-searchFlights-button"
          type="submit"
          variant="primary"
        >
          {t('Button.Text.Search.Air')}
        </Button>
      </Stack>
    </Stack>
  );
};

export default SubmitButtonNew;
